import styled from 'styled-components'
import { breakpoints, colors } from 'style'

export const HowItWorksHeroContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vw / 2.5);
  min-height: 300px;
  display: flex;
  flex-direction: column;
  background-image: url('https://image.anecdobio.com/how_it_works_hero.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  &::before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(13, 0, 0, 0.47);
  }
  .container {
    z-index: 1;
    .home-header-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      h1 {
        color: ${colors.white};
        line-height: 0.95;
      }
    }
  }
  @media (max-width: ${breakpoints.xl}px) {
    .container {
      .home-header-content {
        h1 {
          font-size: 40px;
        }
      }
    }
  }
  @media (max-width: ${breakpoints.md}px) {
    /* height: 497px; */
  }
  @media (max-width: ${breakpoints.sm}px) {
    .container {
      .home-header-content {
        h1 {
          font-size: 32px;
        }
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
